import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select, Button, DatePicker, Tooltip, Icon, Dropdown, Menu } from 'antd';

import Grid from '@material-ui/core/Grid';
import { styles, useStyles } from './OnSiteEvaluationsCalFormStyles';
import TextEvents from 'app/components/TextEvents';

import TableContainer from 'app/containers/TableContainer';
import ApiService from 'app/services/ApiService';
import moment from 'moment';

import { getOnSiteEvaluationsCalFilters, getIsLoadingOnSiteEvaluationsilters } from 'app/reducers';
import { getEvaluationsCalFtF_, exportEvaluationCalFtF_ } from 'app/actions/OnSiteEvaluationsActions';


const { Option } = Select;

// const SelectItem = (name = [], value) => {
//     if (name == null) name = [];
//     let x = name[value]
//     return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

// }

const SelectItemVT = (name = [], value, text) => {
    if (name == null) name = [];

    if (name.length === 0) {
        return <Option disabled key={'cargando'}>No existen valores..</Option>;
    }

    return (
        name.map((item) =>
            <Select.Option key={`${item[value]}`} value={`${item[value]}`}>{item[text]}</Select.Option>
        )
    );
}


const SelectItem_ = (name = [], value) => {
    if (name == null) name = [];

    if (name.length === 0) {
        return <Option disabled key={'cargando'}>No existen valores..</Option>;
    }

    return (
        name.map((item) =>
            <Select.Option key={`${item}`} value={`${item}`}>{item}</Select.Option>
        )
    );
}



export default function OnSiteEvaluationsForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [collapse, setCollapse] = useState(true);
    //const { name } = useSelector(state => state.OnSiteEvaluations.OnSiteEvaluationsFilters);
    const { idSubdirection, employeeId } = useSelector((state) => state.Auth.employeeById);

    let [folioSelected, setFolio] = useState([]);
    let [preEvaluationSel, setPreEvaluationSel] = useState([]);
    let [testFolioSel, setTestFolioSel] = useState([]);
    let [employeeSel, setEmployeeSel] = useState([]);
    let [pernoctaSel, setPernoctaSel] = useState([]);
    let [nameSel, setNameSel] = useState([]);
    let [dateSel, setDateSel] = useState("");

    let evaluationsfilters = useSelector(getOnSiteEvaluationsCalFilters);

    const obj = {
        SubdirectionId: idSubdirection, //10
        EmployeeId: employeeId,
        DateApply: dateSel,
        Fichas: employeeSel,
        TestFolio: testFolioSel,
        IdPresentialEvaluation: preEvaluationSel,
        Pernocta: pernoctaSel,
        CourseFolio: folioSelected,
        CourseName:nameSel,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    };

    const search = () => {
        dispatch(getEvaluationsCalFtF_(obj));
        props.setFormData(obj);
    }

    const Export = () => {
        var payload = {
            SubdirectionId: idSubdirection, //10
            EmployeeId: employeeId,
            DateApply: dateSel,
            Fichas: employeeSel,
            TestFolio: testFolioSel,
            IdPresentialEvaluation: preEvaluationSel,
            Pernocta: pernoctaSel,
            CourseFolio: folioSelected,
            CourseName:nameSel
        }
        var todayDate = new Date().toISOString().slice(0, 10);
        dispatch(exportEvaluationCalFtF_(payload, todayDate));
    }

    return (
        <div>
            <TableContainer>
                {
                    (params) => {
                        return (
                            <div>
                                {/* {JSON.stringify(evaluationsfilters)} */}
                                <div hidden={collapse}>
                                    <Grid container direction="row">
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="Folio"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Folio"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setFolio}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.folio)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="ID de la Evaluación"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Evaluacion"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setPreEvaluationSel}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.idPresentialEvaluation)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="Folio Procedimiento"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Folio Procedimiento"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setTestFolioSel}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.testFolio)
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row">
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="Ficha-Colaborador"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Seleccione Ficha-Colaborador"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setEmployeeSel}
                                            >
                                                {
                                                    SelectItemVT(evaluationsfilters.employee, "employeeId", "name")
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="Pernocta"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Seleccione Pernocta"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setPernoctaSel}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.pernocta)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="Procedimiento"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Seleccione Procedimiento"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setNameSel}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.name)
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction='row'>
                                        <Grid item xs={4}>
                                            <TextEvents
                                                text="Fecha Efectiva"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <DatePicker
                                                style={{ width: '100%' }}
                                                format={'DD/MM/YYYY'}
                                                onChange={(date, dateString) => {
                                                    setDateSel(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                }}
                                                placeholder="Seleccione Fecha"
                                            />
                                        </Grid>


                                    </Grid>
                                    {/* 
                                    <Grid container direction="row">
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Procedimiento/Material de capacitación"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Procedimiento/Material de capacitación"
                                                //onChange={(v, i) => handleChange(v, i, "testFolio")}
                                                onChange={setProcedure}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.name)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Codigo"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Codigo"
                                                onChange={setCode}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.code)
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row">
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Folio"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Folio"
                                                onChange={setFolio}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.folio)
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextEvents
                                                text="Tipo de Capacitacion"
                                                color="darker"
                                                size="label"
                                                weight="medium"
                                            />
                                            <Select
                                                mode="multiple"
                                                showSearch
                                                optionFilterProp="children"
                                                style={styles.inputSelect}
                                                placeholder="Selecciona Tipo de Capacitacion"
                                                onChange={setTraining}
                                            >
                                                {
                                                    SelectItem_(evaluationsfilters.trainings)
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid> */}
                                </div>
                                <div
                                    className={classes.container}
                                    style={styles.baseVerticalMargin}
                                >
                                    {
                                        collapse ?
                                            <Tooltip title={"Mostrar filtro"}>
                                                <Button
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="link"
                                                    onClick={() => setCollapse(false)}
                                                >
                                                    <Icon type="down" />
                                                </Button>
                                            </Tooltip> :
                                            <Tooltip title={"Ocultar filtro"}>
                                                <Button
                                                    className={classes.button}
                                                    variant="contained"
                                                    type="link"
                                                    onClick={() => setCollapse(true)}
                                                >
                                                    <Icon type="up" />
                                                </Button>
                                            </Tooltip>
                                    }
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        onClick={search}
                                    >
                                        Buscar
                                    </Button>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        onClick={Export}
                                    >
                                        Exportar
                                    </Button>
                                </div>
                            </div>

                        )
                    }
                }
            </TableContainer>
        </div>
    )
}